// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__LyXx2","options":"AnswerScale_options__1EQK0","selected":"AnswerScale_selected__3qg1m"};